import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { colors } from "../utils/constants";
import { ReactNode } from "react";

const stripePromise = process.env.REACT_APP_STRAPI_PUBLISHABLE_KEY ? loadStripe(process.env.REACT_APP_STRAPI_PUBLISHABLE_KEY) : null;
const StripeElement = ({ clientSecret, children }: { clientSecret?: string; children: ReactNode }) => {
  const settings: any = {
    appearance: {
      theme: "stripe",
      variables: {
        spacingGridRow: "0",
        spacingGridColumn: "0",
        spacingUnit: "0",
        borderRadius: "0",
      },
      rules: {
        ".Grid": {
          marginBottom: "0px",
        },
        ".Label": {
          fontSize: "0px",
          lineHeight: "0px",
          marginBottom: "0px",
        },
        ".p-CardNumberInput-input": {
          borderTop: "1px",
          borderTopLeftRadius: "8px",
        },
        "#Field-numberInput": {
          backgroundColor: "red",
        },
        ".Input": {
          color: colors.DarkBlue,
          fontSize: "16px",
          fontWeight: "500",
          margin: "10px 0 0 0",
          backgroundColor: "#fff",
          outline: "none",
          boxShadow: "none",
          borderColor: colors.DarkBlue,
        },
        ".Input:focus": {
          outline: "none",
          boxShadow: "none",
        },
        ".Error": {
          color: "red",
        },
        "p-BillingAddressForm": {
          marginTop: "20px",
        },
      },
    },
  };
  if (clientSecret) settings.clientSecret = clientSecret;
  return (
    <Elements stripe={stripePromise} options={settings}>
      {children}
    </Elements>
  );
};

export default StripeElement;
